import {
    ButtonPrimary,
    Divider,
    IconChevronLeftRegular,
    IconCloseRegular,
    NavigationBarAction,
    NavigationBarActionGroup,
    skinVars,
    Spinner,
    Text2,
    Text4,
    Title3,
    useWindowSize,
} from '@telefonica/mistica';
import './index.scss';
import { t } from 'i18next';
import QRCode from 'react-qr-code';
import Logo from '../../../../assets/images/BrandLogoBlue.svg';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getActivationLink, getSIMSInfo } from '../../../../services/ConfigureLineService';
import { getRoleLine } from '../../../../utils/dataTransformation/productConsumption';
import { isWebviewAndroid, isWebviewIOS } from '../../../../utils/navigation/controlDevices';
import { useQuery } from '@tanstack/react-query';
import { useConfigureLineContext } from '../../../../context/configure-line-context/ConfigureLineContext';
import BreadCrumbsWrapper from '../../../../components/BreadcrumbsWrapper';
import useConfigureLine from '../../utils/hooks';

const InstallWithQr: React.FC = () => {
    const size = useWindowSize();
    const [url, setUrl] = useState<string>('');
    const navigate = useNavigate();
    const { lineActive, isConvergent } = useConfigureLineContext();
    const { data: infoSIM } = useQuery({
        queryKey: ['sims-info', lineActive],
        queryFn: () => getSIMSInfo(lineActive),
        enabled: !!lineActive,
    });
    const consumptions = JSON.stringify(window.localStorage.getItem('storages'));
    const { getCorrectResourceId } = useConfigureLine();

    useEffect(() => {
        if (!infoSIM) return;
        getActivationLink(getCorrectResourceId(infoSIM!, 'E_SIM')).then((response: string) => {
            setUrl(`${response}`);
        });
    }, [infoSIM]);

    return (
        <div className='installWithQr'>
            <div className='installWithQr__header'>
                {!(isWebviewAndroid || isWebviewIOS) && (
                    <>
                        <div className='installWithQr__header-navigationBar'>
                            <NavigationBarActionGroup>
                                <NavigationBarAction
                                    onPress={() => {
                                        navigate(`/configure-line`);
                                    }}
                                >
                                    <IconCloseRegular />
                                </NavigationBarAction>
                            </NavigationBarActionGroup>
                        </div>
                        <div
                            className='installWithQr__header-return'
                            onClick={() => {
                                navigate(`/configure-line`);
                            }}
                        >
                            <div className='installWithQr__header-return-icon'>
                                <IconChevronLeftRegular color={skinVars.colors.textPrimary} size={20} />
                            </div>
                            <Text2 medium color={skinVars.colors.textPrimary}>
                                {t('returnResponsive')}
                            </Text2>
                        </div>
                    </>
                )}
                <div className='installWithQr__breadcrumbs'>
                    <BreadCrumbsWrapper
                        title={t('qrBreadcrumbs')}
                        breadcrumbs={
                            !isConvergent
                                ? [
                                      { title: t('breadcrumbsHome'), url: '/home' },
                                      {
                                          title: t('lineManagement'),
                                          url: `/configure-line`,
                                      },
                                  ]
                                : [
                                      { title: t('breadcrumbsHome'), url: '/home' },
                                      {
                                          title: getRoleLine(JSON.parse(consumptions), infoSIM?.productPsId!),
                                          url: `/mobile?productPsId=${infoSIM?.productPsId}`,
                                      },
                                      {
                                          title: t('lineManagement'),
                                          url: `/configure-line`,
                                      },
                                  ]
                        }
                    />
                </div>
            </div>
            <Divider />

            <div className='installWithQr__body'>
                <div className='installWithQr__body-main'>
                    <div className='installWithQr__body-logo'>
                        <img src={Logo} />
                    </div>
                    <div className='installWithQr__body-qr' style={{ display: size.width >= 1024 ? 'none' : '' }}>
                        <QRCode size={160} value={url} />
                    </div>
                </div>
                <div className='installWithQr__body-text'>
                    <Title3>{t('intallWithQRtitle')}</Title3>
                    <Text4 regular>{t('InstallWithQRDescription')}</Text4>
                </div>
                <div className='installWithQr__body-qr' style={{ display: size.width < 1024 ? 'none' : '' }}>
                    <QRCode size={160} value={url} />
                </div>
            </div>

            <div className='installWithQr__bottom'>
                <ButtonPrimary role='onPress' onPress={() => navigate(`/configure-line`)}>
                    {t('finish')}
                </ButtonPrimary>
            </div>
        </div>
    );
};

export default InstallWithQr;
